// import ApiService from "@/api";
// import queryString from "query-string";
import axios from "axios";
import { API_MEWS, HOTEL_ID, CLIENT } from "@/api/config";
import { get, find, pick, includes, map, join } from "lodash";
import ApiService from "@/api";
import moment from "moment";
import queryString from "query-string";
// initial state
const state = () => ({
  loading: false,
  cart: {},
  step: "step1",
  reservation: {},
  paymentConfiguration: null
});

// getters
const getters = {};

// actions
const actions = {
  createBookingByBank({ commit }, params) {
    commit("setLoading", true);
    return new Promise(resolve => {
      const participants =
        get(params, "adult", 0) +
        get(params, "child", 0) +
        get(params, "child1", 0);
      let dataParams = {
        booking_firstname: get(params, "Customer.FirstName"),
        booking_lastname: get(params, "Customer.LastName"),
        booking_email: get(params, "Customer.Email"),
        booking_telephone: get(params, "Customer.Telephone"),
        booking_type: params.type || "",
        booking_camping: params.camping || "",
        booking_date_from: params.dateFrom || "",
        booking_date_to: params.dateTo || "",
        booking_participants: participants,
        booking_options: params.products ? join(params.products, ", ") : "",
        booking_total: params.total,
        status: params.status,
        booking_roomtype: HOTEL_ID
      };
      if (params.reservation) {
        dataParams.booking_reservation = params.reservation;
      }
      if (params.reference) {
        dataParams.booking_reference = params.reference;
      }
      if (params.voucher) {
        dataParams.booking_promotion = params.voucher;
      }
      if (params.categorie) {
        dataParams.booking_category = params.categorie;
      }
      const stringified = queryString.stringify(dataParams);
      let url = `/booking/?${stringified}`;
      ApiService.get(url)
        .then(({ data }) => {
          commit("setLoading", false);
          commit("setReservation", data);
          commit("setStep", "step3");
          commit("setCart", {});
          resolve(data);
        })
        .catch(() => {
          commit("setLoading", false);
          commit("setStep", "step3");
          commit("setCart", {});
          commit("setReservation", null);
        });
    });
  },
  createReservation({ commit }, params) {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_MEWS}/reservationGroups/create`, {
          ...params,
          Client: CLIENT,
          HotelId: HOTEL_ID
        })
        .then(({ data }) => {
          commit("setLoading", false);
          commit("setReservation", data);
          commit("setStep", "step3");
          commit("setCart", {});
          resolve(data);
        })
        .catch(error => {
          // LOG THE REAL MEWS ERROR - check browser console after next failed attempt
          console.error("MEWS createReservation FAILED");
          console.error("Status:", error && error.status);
          console.error("Error body:", JSON.stringify(error && error.data));
          commit("setLoading", false);
          commit("setStep", "step3");
          commit("setCart", {});
          commit("setReservation", null);
          reject(error);
        });
    });
  },
  validateVoucher({ commit }, VoucherCode) {
    commit("setLoading", true);
    return new Promise(resolve => {
      axios
        .post(`${API_MEWS}/vouchers/validate`, {
          VoucherCode,
          Client: CLIENT,
          HotelId: HOTEL_ID
        })
        .then(({ data }) => {
          commit("setLoading", false);
          if (data.IsValid) {
            commit("setCartVoucher", VoucherCode);
          } else {
            commit("setCartVoucher", "");
          }
          resolve(data);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  },
  addProductToCart({ commit }, data) {
    return new Promise(resolve => {
      commit("setProductToCart", data);
      resolve({});
    });
  },
  addToCart({ commit, rootState }, data) {
    commit("setCart", data);
    // check room is promotion
    const promotions = get(rootState, "hotels.promotions", []);
    const infoBook = get(data, "info");
    const room = get(data, "room");
    const promotion = find(promotions, promotion => {
      const promotionStartDate = moment(promotion.start_date, "DD-MM-YYYY");
      const promotionEndDate = moment(promotion.end_date, "DD-MM-YYYY");
      const promotionForRooms = map(
        promotion.reference,
        roomItem => roomItem.Id
      );
      const isValidStartDate = moment(
        infoBook.dateFrom,
        "YYYY-MM-DD"
      ).isBetween(promotionStartDate, promotionEndDate, undefined, "[]");
      const isValidEndDate = moment(infoBook.dateTo, "YYYY-MM-DD").isBetween(
        promotionStartDate,
        promotionEndDate,
        undefined,
        "[]"
      );
      const isValidDate =
        moment(infoBook.dateFrom, "YYYY-MM-DD").diff(
          moment(infoBook.dateTo, "YYYY-MM-DD"),
          "days"
        ) <= 0;
      // console.log("================")
      // console.log("promotion start date", promotionStartDate)
      // console.log("promotion start date", promotionEndDate)
      // console.log("data", data);

      // console.log("isValidStartDate", isValidStartDate);
      // console.log("isValidEndDate", isValidEndDate);
      // console.log("isValidDate", isValidDate);
      // console.log('isValid room', includes(promotionForRooms, room.Id))
      // console.log("================")

      if (
        isValidDate &&
        isValidStartDate &&
        isValidEndDate &&
        includes(promotionForRooms, room.Id)
      ) {
        return promotion;
      }
      return false;
    });
    // console.log("promotion", promotion);
    if (promotion) {
      commit(
        "setCartPromotion",
        pick(promotion, ["name", "code", "end_date", "start_date", "value"])
      );
      commit("setCartVoucher", promotion.code);
    } else {
      commit("setCartPromotion", null);
      commit("setCartVoucher", "");
    }
  },
  clearCart({ commit }) {
    commit("setCart", {});
    commit("setStep", "step1");
  },
  getPricing({ commit }, params) {
    commit("setLoading", true);
    return new Promise(resolve => {
      axios
        .post(`${API_MEWS}/reservations/getPricing`, {
          ...params,
          Client: CLIENT,
          HotelId: HOTEL_ID
        })
        .then(({ data }) => {
          commit("setLoading", false);
          const { OccupancyPrices } = data;
          commit("setOccupancyPrices", OccupancyPrices);
          resolve(data);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  },
  setStep({ commit }, step) {
    commit("setStep", step);
  },
  getPaymentConfiguration({ commit }) {
    commit("setLoading", true);
    return new Promise(resolve => {
      axios
        .post(`${API_MEWS}/hotels/getPaymentConfiguration`, {
          Session: Math.floor(Math.random() * Math.floor(9)),
          Client: CLIENT,
          HotelId: HOTEL_ID
        })
        .then(({ data }) => {
          commit("setLoading", false);
          commit("setPaymentConfiguration", data);
          resolve(data);
        })
        .catch(() => {
          commit("setLoading", false);
          commit("setPaymentConfiguration", null);
        });
    });
  },
  getCardDataFromTransaction({ commit }, transactionId) {
    commit("setLoading", true);
    return new Promise(resolve => {
      ApiService.get(`/pci-proxy?transaction_id=${transactionId}`)
        .then(({ data }) => {
          commit("setLoading", false);
          resolve(data);
        })
        .catch(() => {
          commit("setLoading", false);
        });
    });
  },
  getAvailability({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${API_MEWS}/hotels/getAvailability`, {
          ...params,
          Client: CLIENT,
          HotelId: HOTEL_ID
        })
        .then(({ data }) => {
          commit("setAvailability", data);
          resolve(data);
        })
        .catch(({ data }) => {
          reject(data);
        });
    });
  }
};

// mutations
const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCart(state, data) {
    state.cart = data;
  },
  setAvailability(state, data) {
    const roomCategoryAvailabilities = find(
      data.RoomCategoryAvailabilities,
      item => item.RoomCategoryId === get(state, "cart.room.Id")
    );
    state.cart = {
      ...state.cart,
      room: {
        ...state.cart.room,
        ...roomCategoryAvailabilities
      }
    };
  },
  setProductToCart(state, data) {
    let products = get(state, "cart.products", []);
    const isAdded = find(products, item => item.Id === data.Id);
    if (isAdded) {
      products = products.filter(item => item.Id !== data.Id);
    } else {
      products.push(data);
    }
    state.cart = {
      ...state.cart,
      products
    };
  },
  setCartVoucher(state, data) {
    state.cart = {
      ...state.cart,
      voucher: data
    };
  },
  setCartPromotion(state, data) {
    state.cart = {
      ...state.cart,
      promotion: data
    };
  },
  setOccupancyPrices(state, data) {
    state.cart = {
      ...state.cart,
      occupancyPrices: data
    };
  },
  setStep(state, step) {
    state.step = step;
  },
  setReservation(state, data) {
    state.reservation = data;
  },
  setPaymentConfiguration(state, data) {
    state.paymentConfiguration = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
